import type { AppLocation, AppRoute } from './location$';
import type { EmptyParams, ParamsAt, SearchParamsAt } from './location';
import {
  interpolatePath,
  locationSearchParams,
  searchParamsDeclaredAt,
  toRouteSearchParams,
} from './declarativeRouterLogic';
import { routes, type RouteTree } from './globalRoutes';
import type { Params } from './paramRegistry';
import { withBasePath } from 'basePath';

/**
 * The search params of an app location, serialized with the handlers its route
 * declares.
 */
export const appSearchParams = (
  location: Pick<AppLocation, 'route' | 'searchParams'>
): URLSearchParams => locationSearchParams(routes, location);

export function pathTo<Route extends AppRoute>(
  route: EmptyParams extends ParamsAt<Route> ? Route : never
): string;
export function pathTo<Route extends AppRoute>(
  route: Route,
  params: ParamsAt<Route>,
  searchParams?: SearchParamsAt<RouteTree, Route>
): string;
export function pathTo(
  route: string,
  params: Partial<Params> = {},
  searchParams: Readonly<Record<string, unknown>> = {}
): string {
  const relativePath = interpolatePath({ route, params });
  const search = toRouteSearchParams(
    searchParams,
    searchParamsDeclaredAt(routes, route)
  );
  const searchString = search.toString();
  return withBasePath(
    `/app${relativePath}${searchString ? `?${searchString}` : ''}`
  );
}
